import { render, staticRenderFns } from "./MySponsorship.vue?vue&type=template&id=498fbaaa&scoped=true&"
import script from "./MySponsorship.vue?vue&type=script&lang=js&"
export * from "./MySponsorship.vue?vue&type=script&lang=js&"
import style0 from "./MySponsorship.vue?vue&type=style&index=0&id=498fbaaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498fbaaa",
  null
  
)

export default component.exports